import { bl_alg_cc_qc_link_RowClass as bl_alg_cc_qc_link_RowClass } from "../../../../dbschema/bl_alg_cc_qc_link.model";
import { BaseContainerModel } from "../../../base-container.model";

export class QualityControlLinkContainerModel extends BaseContainerModel {
	bl_alg_cc_qc_link: bl_alg_cc_qc_link_RowClass =
		new bl_alg_cc_qc_link_RowClass();
}
